/**
 * O campo de busca da Base de Conhecimento e o estado dele (spec 2026-10-20-kb-busca).
 * Pastas se filtram na tela; o servidor só é chamado a partir de 3 caracteres, depois de
 * 500 ms sem digitar ou no Enter. A resposta é guardada pelo texto buscado: a de uma busca
 * superada fica na chave dela e nunca aparece sobre a nova.
 */
import { useState } from 'react'
import { CloseButton, TextInput } from '@mantine/core'
import { useDebouncedValue } from '@mantine/hooks'
import { useQuery } from '@tanstack/react-query'
import { IconSearch } from '@tabler/icons-react'
import { buscarNaKb } from '@/api/kb'
import { ATRASO_MS, MINIMO_SERVIDOR } from './busca'

export function useBuscaNaKb(valor: string) {
  const atual = valor.trim()
  const [atrasado] = useDebouncedValue(atual, ATRASO_MS)
  const [confirmado, setConfirmado] = useState<string | null>(null)
  // Enter vale para o texto em que foi dado; digitar de novo volta a esperar o atraso.
  const termo = confirmado === atual ? atual : atrasado
  const consulta = useQuery({
    queryKey: ['kb-busca', termo],
    queryFn: ({ signal }) => buscarNaKb(termo, signal),
    enabled: termo.length >= MINIMO_SERVIDOR,
    staleTime: 30_000,
  })
  return {
    termo,
    /** O resultado só vale para o texto que está no campo */
    atualizado: termo === atual,
    consulta,
    confirmar: () => setConfirmado(atual),
  }
}

interface Props {
  valor: string
  onMudar: (v: string) => void
  onConfirmar: () => void
  onLimpar: () => void
}

export function BuscaNaKb({ valor, onMudar, onConfirmar, onLimpar }: Props) {
  return (
    <TextInput
      size="sm"
      mb="xs"
      placeholder="Buscar pastas e documentos"
      aria-label="Buscar pastas e documentos"
      leftSection={<IconSearch size={14} stroke={1.5} />}
      value={valor}
      onChange={(e) => onMudar(e.currentTarget.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onConfirmar()
        if (e.key === 'Escape') onLimpar()
      }}
      rightSection={valor ? <CloseButton size="sm" aria-label="Limpar busca" onClick={onLimpar} /> : undefined}
    />
  )
}
